import React from 'react';
import { useUpsell } from './UpsellContext';
export const CtaButton = ({
  label = 'SÍ, QUIERO HORNEAR SIN MIEDO',
  price = '$9.990 ARS',
  showPrice = true,
  className = ''
}: {
  label?: string;
  price?: string;
  showPrice?: boolean;
  className?: string;
  href?: string; // accepted for backwards-compat, ignored
}) => {
  const {
    open
  } = useUpsell();
  return <button type="button" onClick={open} className={`inline-flex flex-col items-center justify-center bg-brand-orange text-white font-bold py-3 px-6 rounded-full shadow-md hover:bg-orange-600 transition-colors text-center w-full md:w-auto leading-tight ${className}`} data-id="element-223">
      <span className="text-base md:text-lg" data-id="element-224">{label}</span>
      {showPrice && <span className="text-xs md:text-sm font-medium opacity-95 mt-0.5" data-id="element-225">
          Acceso inmediato por {price}
        </span>}
    </button>;
};
export const VideoPlayer = ({
  src,
  className = ''
}: {
  src: string;
  className?: string;
}) => {
  return <video autoPlay muted loop playsInline className={`w-full max-w-[780px] mx-auto rounded-[18px] shadow-video block ${className}`} data-id="element-226">
      <source src={src} type="video/mp4" data-id="element-227" />
    </video>;
};
export const Section = ({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => {
  return <section id={id} className={`py-10 md:py-16 px-5 sm:px-6 ${className}`} data-id="element-228">
      <div className="max-w-4xl mx-auto" data-id="element-229">{children}</div>
    </section>;
};